/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CurrencyEur(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M192.56934,189.25488a7.99974,7.99974,0,0,1-.001,11.314A80.00019,80.00019,0,0,1,56.40088,152H40a8,8,0,0,1,0-16H56V120H40a8,8,0,0,1,0-16H56.40088A80.00019,80.00019,0,0,1,192.56836,55.43115a7.99984,7.99984,0,1,1-11.3125,11.31446A63.98841,63.98841,0,0,0,72.51758,104H136a8,8,0,0,1,0,16H72v16h48a8,8,0,0,1,0,16H72.51758a63.98841,63.98841,0,0,0,108.73828,37.25439A8.00093,8.00093,0,0,1,192.56934,189.25488Z" />
    </Svg>
  );
}

export default CurrencyEur;
